export default "__VITE_ASSET__CM7FG29S__"